import React from 'react';
import { Col } from 'react-bootstrap';


import './style.scss';

const NPPanel = props => {
  const { children, title, small, centered } = props;

  let titleNode = null;

  if(title) {
    if(typeof(title) === 'string') {
      titleNode = <h2 className="title">{title}</h2>;
    } else {
      titleNode = <h2 className="title">{title}</h2>
    }
  }

  let content = <div className="np-panel">
    {titleNode}

    <div className="row">
      <Col sm={12}>
        {children}
      </Col>
    </div>
  </div>;

  if(small) {
    if(centered) {
      content = <Col sm={12} smOffset={0} lg={6} lgOffset={3}>{content}</Col>;
    } else {
      content = <Col xs={12} sm={6}>{content}</Col>;
    }
  }

  return content;
};

export default NPPanel;